import { Component, inject } from '@angular/core';
import { NotificationService } from '../../../services/notification.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../core/core.module';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'brt-user-notification',
  standalone: true,
  imports: [CommonModule, CoreModule, ButtonModule, BadgeModule, DialogModule],
  templateUrl: './user-notification.component.html',
  styleUrl: './user-notification.component.css'
})
export class UserNotificationComponent {
  private notificationService = inject(NotificationService);
  private snackBar = inject(MatSnackBar);


  permission: string;
  showDialog = false;
  unreadCount?: number;
  notifications?: any[];

  constructor() {
    this.notificationService.permission$.pipe(takeUntilDestroyed()).subscribe(async permission => {
      console.debug('Notification permission:', permission);
      if (permission === 'default')
        await this.requestPermission();
      else
        this.permission = permission
    });
    this.notificationService.messages$.pipe(takeUntilDestroyed()).subscribe(async () => await this.loadNotifications());
  }

  async ngOnInit() {
    await this.loadNotifications();
  }

  async loadNotifications() {
    this.notifications = await this.notificationService.getUserNotifications();
    this.unreadCount = this.notifications?.filter(n => !n.IsRead).length;
  }

  async requestPermission() {
    const snackbarRef = this.snackBar.open('Please allow notifications to receive important messages.', 'OK', {
      horizontalPosition: 'left',
      verticalPosition: 'top',
    });
    snackbarRef.onAction().subscribe(async () => await this.notificationService.requestPermission());
  }

  async expand(notification: any) {
    notification.IsRead = true;
    notification._expanded = true;
    this.unreadCount = this.notifications?.filter(n => !n.IsRead).length;
    await this.notificationService.markAsRead([notification.Id]);
  }

  async markAllAsRead() {
    await this.notificationService.markAsRead(this.notifications.filter(n => !n.IsRead).map(n => <string>n.Id));
  }


}
